module.exports = __webpack_public_path__ + "img/ads1.0ab67d0.webp";